 import firebase from 'firebase/app'
 import 'firebase/firestore'
 import 'firebase/auth'

 var firebaseConfig = {
    apiKey: "AIzaSyAWQvOKNJcfV-SLExZTe86xorgB5EOONAw",
    authDomain: "photogems-95ea0.firebaseapp.com",
    databaseURL: "https://photogems-95ea0.firebaseio.com",
    projectId: "photogems-95ea0",
    storageBucket: "photogems-95ea0.appspot.com",
    messagingSenderId: "392619936611",
    appId: "1:392619936611:web:504964b9dd7c60c2a26156",
    measurementId: "G-S9K55Z9M68"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  
  export default firebase